import { useDispatch } from "react-redux";
import DesignationTimelineSvg from "./DesignationTimelineSVG";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import tw from "tailwind-styled-components";
import RoleEditSinglePopup from "./PopUp/RoleEditSinglePopup";

const RoleHistoryStatus = ({ list, edit, setLoading }) => {
  const user_id = useParams("id");
  const dispatch = useDispatch();

  const deletedRoleHistory = async (id) => {
    setLoading(true);
    //   const { data } = await dispatch(deleteRoleHistory(id));
    //   if (data.message === "success") {
    //     dispatch(loadSingleStaff(user_id.id));
    //     setLoading(false);
    //   } else {
    //     setLoading(false);
    //   }
  };

  const RoleList = Array.isArray(list) ? list : list ? [list] : [];

  return (
    <div>
      <main className="container mx-auto w-full flex justify-center mt-5">
        <ol className="border-l-2 border-slate-600">
          {RoleList.length > 0 &&
            RoleList.map((item, index) => (
              <li key={index}>
                <div className="md:flex flex-start">
                  <DesignationTimelineSvg />
                  <div className="block p-6 max-w-md ml-6 mb-5">
                    <div className="flex justify-between mb-4">
                      <Heading>{item?.RoleName}</Heading>
                      <Heading>
                        {dayjs(item?.EffectedFrom).format("MMM YYYY")} -{" "}
                        {item?.EffectedTo
                          ? dayjs(item?.EffectedTo).format("MMM YYYY")
                          : "Present"}
                      </Heading>
                      {edit && (
                        <div>
                          <RoleEditSinglePopup
                            data={item}
                            setLoading={setLoading}
                          />
                          <button
                            onClick={() =>
                              deletedRoleHistory(item.RoleHistoryId)
                            }
                          >
                            {/* <BtnDeleteSvg size={20} /> */}
                          </button>
                        </div>
                      )}
                    </div>
                    <Heading1>
                      Start Date:{" "}
                      <Heading2>
                        {item?.EffectedFrom
                          ? dayjs(item?.EffectedFrom).format("DD/MM/YYYY")
                          : "N/A"}
                      </Heading2>
                    </Heading1>
                    <Heading1>
                      End Date:{" "}
                      <Heading2>
                        {item?.EffectedTo
                          ? dayjs(item?.EffectedTo).format("DD/MM/YYYY")
                          : "Present"}
                      </Heading2>
                    </Heading1>
                  </div>
                </div>
              </li>
            ))}
          {RoleList.length === 0 && (
            <div className="p-4 text-center">No Role history available</div>
          )}
        </ol>
      </main>
    </div>
  );
};

const Heading = tw.h3`
font-medium
text-base
mr-20
w-500
txt-color-2
`;

const Heading1 = tw.h3`
font-medium
text-sm
mr-20
w-500
txt-color-2
`;

const Heading2 = tw.span`
font-medium 
text-sm
txt-color-secondary`;

export default RoleHistoryStatus;
